// Lib
import * as _ from 'lodash';
import { put, call, takeLatest } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";

// Types
import { ActionGetLMImagesAPI, getLMImagesAPISuccess, getLMImagesAPIError, getLMImagesAPI, ActionPostLMImagesAPI, postLMImagesAPISuccess, postLMImagesAPI, postLMImagesAPIError } from './actions';
import { LMimages, LMMediadata } from './types';

import { createAPINetworkInstance } from '../../../../../common/api';
import { parseAPILMimages, parseUILMimages } from './utils';

function* getDealerLMImages(action: ActionGetLMImagesAPI) {
    try {

        const { listingId } = action
        const { data } = yield call(createAPINetworkInstance().get, `listing/${listingId}/media`);
        const lmimages: LMimages = parseAPILMimages(data);
        yield put(getLMImagesAPISuccess(lmimages));
    } catch (err) {
        yield put(getLMImagesAPIError());
    }
}


function* postDealerLMImages(action: ActionPostLMImagesAPI) {
    try {
        const { listingId, images, engine } = action
        const apiLMImages = [...images]
        const data = { mediadata: apiLMImages };
        const response = yield call(createAPINetworkInstance().post, `listing/${listingId}/media?engine=${engine}`, data);
        yield put(postLMImagesAPISuccess(response.data));
    } catch (err) {
        yield put(getLMImagesAPIError());
    }
}

export default function* dealerLMImagesSagas() {
    yield takeLatest(ACTIONS.POST_LMIMAGES_API_REQUEST, postDealerLMImages);
    yield takeLatest(ACTIONS.GET_LMIMAGES_API_REQUEST, getDealerLMImages);
}